import { useStoreActions } from '~/contexts';
import { useMutationState } from '../useMutationState';
export const useGenerateNotificationRewrite = ()=>{
    const { api } = useStoreActions();
    const start = useMutationState({
        mutationFn: async (request)=>api.notificationRewrite.startConversation(request),
        withPageLoader: false
    });
    const continueConv = useMutationState({
        mutationFn: async (param)=>{
            let { conversationId, request } = param;
            return api.notificationRewrite.continueConversation(conversationId, request);
        },
        withPageLoader: false
    });
    return {
        startConversation: start.mutateAsync,
        sendMessage: (conversationId, request)=>continueConv.mutateAsync({
                conversationId,
                request
            }),
        isLoading: start.isPending || continueConv.isPending,
        isError: start.isError || continueConv.isError
    };
};
